import React from 'react';
import classNames from 'classnames';

import {Truncate} from '@cleartrip/bento'
import { scrollTo } from 'helper/scrollTo';

function SideBarItem(props) {
	const { className, children, scrollToRef, handler, ...otherProps } = props;
	const wrapperClassName = classNames('hover:bg-secondary-0 p-2 flex c-pointer flex-1 nmx-2 br-4 td-none');
	const itemClassName = classNames('fs-3 fw-500 c-secondary-500');
	function clickHandler(){
		scrollToRef && scrollTo(scrollToRef)
		handler && handler(otherProps)
	}
	return (
		<a {...otherProps} onClick={() => clickHandler()} className={wrapperClassName}>
			<Truncate width="207px" className={itemClassName}>{children}</Truncate>
		</a>
	);
}

export default SideBarItem;
